<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 bg-top">
            <div class="row topHeader">
                <div class="col-md-3" routerLink="/index">
                    <img src="assets/images/main-logo.png" class="logo">
                </div>
                <div class="col-md-9 rightList">
                    <div class="sameWidth">
                        <div class="topD">
                            <ul>
                                <!-- <li class="red"><a routerLink="/index/tarifftester"><i class="material-icons">input</i></a>
                                </li>
                                <li class="green"><a href="#"><i class="material-icons-outlined">call</i></a> </li>
                                <li><a href="#"><i class="material-icons-outlined">arrow_downward</i></a> </li>
                                <li>
                                    <div class="notification">
                                        <div class="pulseCircle"></div>
                                        <div class="count">40</div>
                                        <a href="#"><i class="material-icons-outlined">message</i></a>
                                    </div>
                                </li>
                                <li>
                                    <div class="notification">
                                        <div class="pulseCircle"></div>
                                        <div class="count">99+</div>
                                        <a routerLink="/index/liveview"><i
                                                class="material-icons-outlined">notifications_none</i></a>
                                    </div>
                                </li> -->
                                <li><a routerLink="/"><i class="material-icons-outlined">power_settings_new</i></a> </li>
                            </ul>
                        </div>
                        <div class="topD">
                            <span class="username">{{storedData}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- end of col-md-12 -->

        <router-outlet></router-outlet>

    </div>
</div> <!-- end of container-fluid -->